import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/models/employee.model';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { ServiceType } from 'src/app/models/service_type.model';
import { ServiceTypeService } from 'src/app/services/service_type.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'service-type-table',
    templateUrl: './service_type_table.component.html',
    styleUrls: ['./service_type_table.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatButton, MatIconButton, MatSuffix, MatIcon, MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, DatePipe]
})
export class ServiceTypeTableComponent implements OnInit {
    employee!: Employee;
    serviceTypes: ServiceType[] = [];
    serviceTypeDataSource = new MatTableDataSource<ServiceType>([]);
    serviceTypeColumnHeaders: string[] = ['name', 'status', 'dateModified', 'action'];
    newServiceTypeName = '';

    loading = false;

    constructor(
        private router: Router,
        private storage: TokenStorageService,
        private serviceTypeService: ServiceTypeService,
    ) {}

    ngOnInit(): void {
        this.employee = this.storage.getUser();
        if (this.employee.employeeRole === 'Admin') {
            this.getAllServiceTypes();
        } else {
            this.router.navigate(['home']);
        }
    }

    getAllServiceTypes(): void {
        this.loading = true;
        this.serviceTypeService
            .getAll(['All'], new Map())
            .subscribe(x => {
                this.serviceTypes = x;
                this.loading = false;
                this.refreshServiceTypeTable();
            }, (_) => this.loading = false
        );
    }

    addServiceType(): void {
        this.loading = true;

        const name = this.newServiceTypeName;

        this.serviceTypeService
            .post([], { name })
            .subscribe(_ => {
                this.loading = false;
                this.getAllServiceTypes();
            }, (_) => this.loading = false
        );
    }

    toggleServiceType(serviceTypeId: string, isDelete: boolean): void {
        const serviceTypeStatus = isDelete ? 'INACTIVE' : 'ACTIVE';

        this.serviceTypeService
            .put([serviceTypeId], { serviceTypeStatus, serviceTypeId })
            .subscribe(_ => {
                this.loading = false;
                this.getAllServiceTypes();
            }, (_) => this.loading = false
        );
    }

    refreshServiceTypeTable(): void {
        this.serviceTypeDataSource.data = this.serviceTypes;
    }
}
